import { UserLayoutProvider } from "@mcleod/common";

export class LMEUserLayoutProvider extends UserLayoutProvider{
    override get layoutPath(): string {
        return "lme/general/user/LMEUser";
    }
}
